import React, { FC } from 'react';
import { Box, LinearProgress, LinearProgressProps, Typography } from '@mui/material';

interface FileUploadProgressComponentProps extends LinearProgressProps {
    value: number;
    filename: string;
}

const FileUploadProgressComponent: FC<FileUploadProgressComponentProps> = (props) => {
    const { value, filename } = props;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', mt: 2 }}>
            <Box>
                <Typography>{filename}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }} data-testid="FileUploadProgressComponent">
                <Box sx={{ width: '100%', mr: 1 }}>
                    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                    <LinearProgress variant="determinate" {...props} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                    <Typography variant="body2" color="text.secondary">
                        {`${Math.round(
                            value,
                        )}%`}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default FileUploadProgressComponent;
